import { CONTACT_CREATE_ATTRIBUTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const ContactCreateAttribution = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  objectTypeId: CONTACT_CREATE_ATTRIBUTION_TYPE_ID,
  referenceObjectType: 'CONTACT_CREATE_ATTRIBUTION_PROPERTIES'
});
export default ContactCreateAttribution;